<ng-container *ngIf="!!formGroup && !!formGroup.get(formControlName)">
  <div class="p-float-label">
    <p-autoComplete
      #autoComplete
      class="p-inputwrapper-focus"
      [ngClass]="{ 'text-uppercase': uppercase && !selectFromList && !getControl().value, 'show-spinner': isSearching }"
      [(ngModel)]="selectedObjectToDisplay"
      [suggestions]="filteredItems"
      [dropdown]="dropdown"
      [minLength]="searchOnlyByEnterKey ? 99999 : minLength"
      [placeholder]="placeholder"
      [showClear]="showClear && !isSearching && !!getControl().value"
      [field]="field"
      [forceSelection]="forceSelection"
      [readonly]="readonly && !!getControl().value"
      (onSelect)="onSelected($event)"
      (completeMethod)="onSearchInput($event)"
      (onClear)="onCleared()"
      (keydown.enter)="searchByEnter($event)"
    >
      <ng-template pTemplate="selectedItem" let-selectedOption>
        <div class="flex align-items-center gap-2">
          <div>{{ selectedOption[field] }}</div>
        </div>
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ item[field] }}</div>
        </div>
      </ng-template>
    </p-autoComplete>
    <label [ngClass]="{ required: required, 'label-disabled': isDisabled }">{{ name }}</label>
  </div>
</ng-container>
